<template>
  <loader v-if="loading" />
  <div class="pagination-container">
    <div class="pagination">
      <!-- Previous -->
      <a href="#" @click="prevPage" :class="{ disabled: currentPage === 1 }">
        Previous
      </a>

      <!-- Page numbers -->
      <span
        v-for="(pageNumber, index) in displayedPages"
        :key="index"
        @click="pageNumber !== '...' && changePage(pageNumber)"
        :class="{
          active: pageNumber === currentPage,
          clickable: pageNumber !== '...' && pageNumber !== currentPage,
          dots: pageNumber === '...',
        }"
      >
        {{ pageNumber }}
      </span>

      <!-- Next -->
      <a
        href="#"
        @click="nextPage"
        :class="{ disabled: currentPage === totalPags }"
      >
        Next
      </a>
    </div>

    <!-- Page info -->
    <div class="page-info">
      Showing Records {{ startRecord }}–{{ endRecord }} of
      {{ totalRecords }} Total Records
    </div>
  </div>
</template>

<script>
import loader from "../special_clinics/dialysis/loader.vue";
import { generalApiRequest } from "../../api/apiIndex";

export default {
  props: {
    allData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      exportData: [],
      currentPage: 1,
      totalPags: 1,
      perPage: 1,
      totalItems: 1,
      totalRecords: 1,
      maxDisplayedTabs: 5,
      links: [],
      loading: false,
    };
  },
  components: {
    loader,
  },
  computed: {
    displayedPages() {
      const pages = [];
      const total = this.totalPags;
      const current = this.currentPage;

      if (total <= 8) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) pages.push(i);
          pages.push("...");
          for (let i = total - 3; i <= total; i++) pages.push(i);
        } else if (current >= total - 3) {
          for (let i = 1; i <= 4; i++) pages.push(i);
          pages.push("...");
          for (let i = total - 4; i <= total; i++) pages.push(i);
        } else {
          for (let i = current - 2; i <= current + 2; i++) pages.push(i);
          pages.push("...");
          for (let i = total - 3; i <= total; i++) pages.push(i);
        }
      }
      return pages;
    },
    startRecord() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    endRecord() {
      return Math.min(this.currentPage * this.perPage, this.totalRecords);
    },
  },
  methods: {
    changePage(pageNumber) {
      this.handlePageChange(pageNumber);
    },
    nextPage() {
      if (this.currentPage < this.totalPags) {
        this.handlePageChange(this.currentPage + 1);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.handlePageChange(this.currentPage - 1);
      }
    },
    async handlePageChange(pageNumber) {
      this.$emit("loader-set", true);
      this.loading = true;
      const link = this.links.find(l => l.label == pageNumber);
      if (!link || !link.url) return;

      const data = await generalApiRequest(link.url, "GET", {}, 2);

      this.exportData = data.data.data;
      this.currentPage = data.data.current_page;
      this.totalPags = data.data.last_page;
      this.perPage = data.data.per_page;
      this.totalItems = data.data.total;
      this.totalRecords = data.data.total;
      this.links = data.data.links;

      this.$emit("content-change", this.exportData);
      this.$emit("loader-set", false);
        this.loading = false;
    },

    // async handlePageChange(pageNumber) {
    //   this.$emit("loader-set", true);
    //   this.loading = true;
    //   this.currentPage = pageNumber;
    //   try {
    //     const url = this.links[pageNumber].url;
    //     const data = await generalApiRequest(url, "GET", {}, 2);

    //     this.exportData = data.data.data;
    //     this.currentPage = data.data.current_page;
    //     this.totalPags = data.data.last_page;
    //     this.perPage = data.data.per_page;
    //     this.totalItems = data.data.total;
    //     this.totalRecords = data.data.total;
    //     this.links = data.data.links;

    //     this.$emit("content-change", data.data.data);
    //     this.$emit("loader-set", false);
    //     this.loading = false;
    //   } catch (error) {
    //     console.error(error);
    //   }
    // },
    preparePagination() {
      this.exportData = this.allData.data;
      this.currentPage = this.allData.current_page;
      this.totalPags = this.allData.last_page;
      this.perPage = this.allData.per_page;
      this.totalItems = this.allData.total;
      this.totalRecords = this.allData.total;
      this.links = this.allData.links;

      this.$emit("content-change", this.exportData);
    },
  },
  beforeMount() {
    this.preparePagination();
  },
};
</script>

<style scoped>
/* Pagination styles */
.pagination-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 1em;
}

.pagination {
  margin-top: 10px;
}

.pagination a,
.pagination span {
  padding: 5px 10px;
  margin: 0 5px;
  border: 1px solid #ccc;
  text-decoration: none;
  color: #333;
}

.pagination a:hover {
  background-color: #f0f0f0;
}

.pagination .active {
  background-color: #007bff;
  color: #fff;
  cursor: default;
}

.pagination .disabled {
  pointer-events: none;
  opacity: 0.5;
}

.pagination .dots {
  border: none;
  pointer-events: none;
}

.page-info {
  margin-top: 10px;
  font-size: 14px;
}
</style>
